<!--
 * @Description: 用户账户解休眠
-->
<template>
	<div class="perfect_info">
		<div class="container">
			<div class="title">{{ $t("login.unsleep.title") }}</div>
			<a-form-model :model="form" ref="formRef" :rules="rules" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
				<a-form-model-item :label="$t('login.unsleep.account')" prop="account">
					<a-input v-model="form.account" :placeholder="$t('login.unsleep.accountPlaceholder')" disabled></a-input>
				</a-form-model-item>
				<a-form-model-item :label="$t('login.unsleep.password')" prop="password">
          <a-input v-model="form.password" :placeholder="$t('login.unsleep.passwordPlaceholder')" disabled></a-input>
        </a-form-model-item>
				<a-form-model-item :label="$t('login.unsleep.username')" prop="username">
          <a-input v-model="form.username" :placeholder="$t('login.unsleep.usernamePlaceholder')" allowClear></a-input>
        </a-form-model-item>
				<a-form-model-item :label="$t('login.unsleep.idCard')" prop="idCard">
          <a-input v-model="form.idCard" :placeholder="$t('login.unsleep.idCardPlaceholder')" allowClear></a-input>
        </a-form-model-item>
			</a-form-model>

			<div class="footer">
				<a-button @click="goLogin">{{ $t("base.btn.back_login") }}</a-button>
				<a-button type="primary" @click="handleConfirm">{{ $t("base.btn.sure") }}</a-button>
			</div>
		</div>
	</div>
</template>

<script>
import { commonAPI } from "@/apis";
import { commonMethods } from "../mixins/common";

// 验证身份证号
const idCardValidator = (rule, value, callback) => {
  const regex = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
  if (regex.test(value)) {
    callback()
  } else {
    callback('请输入正确的身份证号')
  }
}

export default {
	name: "Unsleep",
	mixins: [commonMethods],
	data() {
		return {
			form: { 
        account: "", // 账号
        password: "", // 密码
        username: "", // 姓名
        idCard: "", // 身份证号
      },
      before_login: {},
			rules: {
				username: [
					{ required: true, message: this.$t("login.unsleep.usernamePlaceholder") }
				],
        idCard: [
					{ required: true, message: this.$t("login.unsleep.idCardPlaceholder") },
          // 后台管理在新增用户的时候没有对身份证号进行校验 此处也不校验
          // { validator: idCardValidator, trigger: 'blur' } 
				],
			},
		};
	},
	beforeRouteEnter(to, from, next) {
		next((vm) => {
			// 判断是否可进入该路由
			let before_login = JSON.parse(sessionStorage.getItem("BEFORE_LOGIN"));
			if (!before_login || !before_login.isSleep) {
				vm.$router.replace({ path: from.path });
			} else {
        vm.before_login = { ...before_login };
        const { account, password } = JSON.parse(sessionStorage.getItem("LOGIN_INFO"));
        vm.form.account = account;
        vm.form.password = password;
			}
		});
	},
	methods: {
    // 点击确认按钮
		handleConfirm() {
      this.$refs.formRef.validate(valid => {
        if (!valid) return
        // 表单验证通过
        this.handleOk()
      })
    },
    async handleOk() {
      const params = {
        username: this.form.account,
        password: this.form.password,
        xm: this.form.username,
        idCardNo: this.form.idCard
      };
      const { code, message } = await commonAPI.postAction("/active/activeAccount ", params);
      if (code === 0) {
        this.$message.success(message);
        this.before_login.isSleep = false;
        sessionStorage.setItem("BEFORE_LOGIN", JSON.stringify(this.before_login));
        this.jumpComputed();
      } else {
        this.$message.error(message);
      }
    }
	},
};
</script>

<style lang="less" scoped>
.perfect_info::v-deep {
	width: 100%;
	height: 100%;
	padding-top: 35px;
	.container {
		max-width: 800px;
		width: 80%;
		margin: 0 auto;
		background-color: #fff;
		padding: 30px 0;
		border-radius: 20px;
		.title {
			font-size: 22px;
			text-align: center;
			margin-bottom: 20px;
		}
	}

	.ant-input[disabled] {
		color: rgba(0, 0, 0, 0.65);
	}

	.footer {
		text-align: center;
		margin-top: 10px;
		.ant-btn + .ant-btn {
			margin-left: 40px;
		}
	}
}
</style>
